var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitTrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.7,16c-0.3,0.3-0.6,0.6-1,0.9c-1.9-1.7-3.3-3.2-4.2-4.6c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2,0-0.3,0-0.5,0 c-0.5,0-1.1-0.1-1.5-0.3c0.3,0.6,0.6,1.2,1.1,1.9c1.2,1.8,3,3.7,5.5,5.7c0.6-0.5,1.1-1,1.6-1.4c0.5-0.5,1-0.9,1.4-1.4l-1.2-1.2 C11.3,15.4,11,15.7,10.7,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.3,9c0,0.2-0.1,0.4-0.1,0.5H17C17,9.4,17,9.2,17,9s0-0.4,0-0.5c0-2.1-0.7-3.8-2.1-5.3 c-1.4-1.4-3.1-2.1-5.2-2.1c-2.1,0-3.8,0.7-5.2,2.1C4,3.7,3.6,4.3,3.3,4.9c0.4-0.2,0.9-0.3,1.4-0.3c0.3,0,0.5,0,0.8,0.1 c0.1-0.1,0.1-0.2,0.2-0.3c1.1-1.1,2.4-1.6,4-1.6s2.9,0.5,4,1.6c1.1,1.1,1.6,2.4,1.6,4.1C15.4,8.7,15.4,8.8,15.3,9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "17.6,12.1 14.1,12.1 15.4,10.8 14.2,9.6 10.9,12.9 14.2,16.3 15.4,15.1 14.1,13.8 17.6,13.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "3.3,8.7 6.8,8.7 5.5,10.1 6.7,11.2 10,7.9 6.7,4.5 5.5,5.7 6.8,7 3.3,7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitTrip);
export default __webpack_public_path__ + "static/media/split-trip.ffdc07dcbebde2cc9c46c3a508ba526f.svg";
export { ForwardRef as ReactComponent };